import logo200Image from '../assets/img/logo/logo_2.png';
import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import Typography from '../components/Typography';
import axios from 'axios';
import { MdCameraAlt, MdFace, MdDone, MdClear } from 'react-icons/md';
import Avatar from '../components/Avatar';
import userPlaceholder from '../assets/img/users/profile.jpg';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { getTax } from '../utils/dropdownlist';
import update from 'immutability-helper';

class PosProductForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      isStock: false,
      isGlobal: true,
      actionList: [
        { name: 'Adjust' },
        { name: 'Add Stock' },
        { name: 'Deduct Stock' },
      ],
      stockAction: '',
      qty_data: '',
      amount: '',
      productList: [],
      product_id: '',
      product_no: '',
      store_id: '',
      company_id: '',
      price_data: '',
      alerts: '',
      follow_price: 0,
    };
  }

  componentDidMount() {
    if (this.props.data.isGlobal) {
    } else {
      if (this.props.data.isEdit) {
        let id = this.props.data.selectedId;
        // const data = this.props.data.productList.find(e => e.id === id);
        const data = this.props.data;
        this.setState({
          product_id: id,
          product_no: data.product_no,
          name: data.name,
          price_data: data.price_data,
          alerts: data.alerts,
          isEdit: true,
          isStock: false,
          isGlobal: this.props.data.isGlobal,
          store_id: this.props.data.store_id,
          follow_price: this.props.data.follow_price,
        });
      } else if (this.props.data.isStock) {
        let id = this.props.data.selectedId;
        //const data = this.props.data.productList.find(e => e.id === id);
        const data = this.props.data;
        this.setState({
          product_id: id,
          product_no: data.product_no,
          name: data.name,
          price_data: data.price_data,
          alerts: data.alerts,
          qty_data: data.qty_data,
          isEdit: false,
          isStock: true,
          isGlobal: this.props.data.isGlobal,
          store_id: this.props.data.store_id,
        });
      } else {
        this.setState({
          store_id: this.props.data.store_id,
          isGlobal: this.props.data.isGlobal,
        });
      }
    }
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  alertChangeHandler = event => {
    const { name, value } = event.target;
    const newData = update(this.state.alerts, {
      stock_warning: { [name]: { $set: value } },
    });
    this.setState({
      alerts: newData,
    });
  };

  priceChangeHandler = event => {
    const { name, value } = event.target;
    this.setState({
      price_data: update(this.state.price_data, {
        0: { [name]: { $set: value } },
      }),
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    if (this.state.isGlobal) {
      //   if (!this.state.isEdit) {
      //     this.editTax(user, url);
      //   } else {
      //     this.createTax(user, url);
      //   }
    } else {
      if (this.state.isEdit) {
        this.editProduct(user, url);
      } else {
        this.adjustStock(user, url);
      }
    }
  };

  editProduct(user, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      product_id: this.state.product_id,
      store_id: this.state.store_id,
      price_data: JSON.stringify(this.state.price_data),
      alerts: JSON.stringify(this.state.alerts),
      update_by: user.email,
    };
    axios
      .post(url + ':3002/v1/product/store/update', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Product updated successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        console.log(error);
        if (error.response) {
          alert(error.response.data.message);
        }
        // else if (error.request) {
        //   console.log(error.request);
        // }
        else {
          alert('Error', error.message);
        }
      });
  }

  adjustStock(user, url) {
    let fullUrl;
    let qtyData = [...this.state.qty_data];
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      product_id: this.state.product_id,
      store_id: this.state.store_id,
    };
    if (this.state.stockAction === 'Adjust') {
      qtyData[0].qty = this.state.amount;
      fullUrl = url + ':3002/v1/product/store/inventory/adjust';
      data.qty_data = JSON.stringify(qtyData);
      data.adjust_by = user.email;
    } else {
      qtyData[0].qty =
        this.state.stockAction === 'Add Stock'
          ? this.state.amount
          : '-' + this.state.amount;
      fullUrl = url + ':3002/v1/product/store/inventory/add';
      data.qty_data = JSON.stringify(qtyData);
      data.updated_by = user.email;
    }

    axios
      .post(fullUrl, data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Stock updated successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        if (error.response) {
          alert(error.response.data.message);
        }
        // else if (error.request) {
        //   console.log(error.request);
        // }
        else {
          alert('Error', error.message);
        }
      });
  }

  render() {
    let { price_data, alerts } = this.state;

    console.log(this.state);
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>
          Product Details
        </ModalHeader>
        <ModalBody>
          {this.state.isEdit ? (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="tax_code">Product No.</Label>
                  <Input
                    type="text"
                    name="product_no"
                    value={this.state.product_no}
                    readOnly
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="name">Name</Label>
                  <Input
                    type="text"
                    name="name"
                    value={this.state.name}
                    readOnly
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Price</Label>
                  <Input
                    type="text"
                    name="price"
                    value={price_data[0] && price_data[0].price}
                    onChange={this.priceChangeHandler}
                    required={!this.state.follow_price}
                    readOnly={this.state.follow_price}
                  />
                </FormGroup>
                {/* <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      name="follow_price"
                      checked={this.state.follow_price}
                      readOnly
                      //onChange={this.checkHandler}
                    />
                    Follow Price
                  </Label>
                </FormGroup>
                <br /> */}
                <FormGroup>
                  <Label>Stock Warning</Label>
                  <Input
                    type="text"
                    name="warn"
                    value={alerts && alerts.stock_warning.warn}
                    onChange={this.alertChangeHandler}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Stock Alert</Label>
                  <Input
                    type="text"
                    name="alert"
                    value={alerts && alerts.stock_warning.alert}
                    onChange={this.alertChangeHandler}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>No Order</Label>
                  <Input
                    type="text"
                    name="no_order"
                    value={alerts && alerts.stock_warning.no_order}
                    onChange={this.alertChangeHandler}
                  />
                </FormGroup>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label>Quantity</Label>
                  <Input
                    type="text"
                    name="qty"
                    value={this.state.qty_data && this.state.qty_data[0].qty}
                    readOnly
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="stockAction">Action</Label>
                  <Input
                    type="select"
                    name="stockAction"
                    value={this.state.stockAction}
                    onChange={this.changeHandler}
                    required
                  >
                    <option></option>
                    {this.state.actionList.map(item => {
                      return (
                        <option key={item.name} value={item.name}>
                          {item.name}
                        </option>
                      );
                    })}
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label>Quantity</Label>
                  <Input
                    type="text"
                    name="amount"
                    value={this.state.amount}
                    onChange={this.changeHandler}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    );
  }
}

export const STATE_ADD = 'ADD';
export const STATE_EDIT = 'EDIT';
export default PosProductForm;
